export class UnpivotModel {
  constructor(
    public unpivotColumns: string[] = [''],
    public forColumn = '',
    public groups: UnpivotGroup[] = [new UnpivotGroup()],
  ) {}
}

export class UnpivotGroup {
  constructor(public alias = '', public columns: string[] = []) {}
}

// When unpivot columns length = 1 then groups length must be 1
// When unpivot columns length > 1 then columns length should be equal to unpivot columns length
// All group.columns should be uniuqe
